import { For, Show } from "solid-js";
import type { MeetingInsights } from "../types/insights";

export default function EntitiesPanel(props: {
  info: MeetingInsights | null;
  onToggle?: (id: string) => void; 
  loading?: boolean;
  error?: string;
}) {
  const hasPeople = !!props.info?.peopleWithRoles?.length;
  const hasPhrases = !!props.info?.keyPhrases?.length;
  if (!props.info || (!hasPeople && !hasPhrases)) return null;

  return (
    <div class="card ">
      <h2 class="text-lg font-semibold mb-3">
        {hasPeople ? "People Identified" : "Key Phrases"}
      </h2>

      {/* People with Roles Section */}
      <Show when={hasPeople}>
        <div>
          <div class="space-y-2">
            <For each={props.info!.peopleWithRoles}>
              {(person) => (
                <div class="bg-green-50 border border-green-200 rounded-md p-3">
                  <div>
                    <div class="font-medium text-green-900">{person.name}</div>
                    <div class="text-sm text-green-700 capitalize">
                      Role: {person.role}
                    </div>
                    <Show when={person.age}>
                      <div class="text-xs text-green-600">Age: {person.age}</div>
                    </Show>
                  </div>
                </div>
              )}
            </For>
          </div>
        </div>
      </Show>

      {/* Key Phrases Section */}
      <Show when={hasPhrases}>
        <div class={hasPeople ? "mt-4 pt-4 border-t border-gray-200" : ""}>
          <h3 class="text-sm font-semibold mb-2">Key Phrases</h3>
          <div class="flex flex-wrap gap-2">
            <For each={props.info!.keyPhrases}>
              {(phrase) => (
                <span class="text-xs bg-blue-100 text-blue-800 px-2 py-1 rounded-full">
                  {phrase}
                </span>
              )}
            </For>
          </div>
        </div>
      </Show>
    </div>
  );
}
